import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { pt } from "./pt"
import { es } from "./es"

const userLang = navigator.language || navigator.userLanguage
const defaultLang = userLang.substr(0,2)

i18next.use(initReactI18next)
i18next.init({
    interpolation: {
        escapeValue: false
    },
    lng: defaultLang,
    fallbackLng: 'es',
    resources: {
        pt: {
            translation: pt
        },
        es: {
            translation: es
        }
    }
})

// Declare the page's real language for assistive tech; translation itself is blocked by
// translate="no" and the notranslate meta in public/index.html. Warehouse selection calls
// changeLanguage, so this follows it.
const syncDocumentLanguage = () => {
    document.documentElement.lang = i18next.resolvedLanguage || 'es'
}

syncDocumentLanguage()
i18next.on('languageChanged', syncDocumentLanguage)

export default i18next
